import { create } from 'zustand'

interface AssetPopupState {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export const useAssetPopupStore = create<AssetPopupState>()((set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen }),
}))
